'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/index.js
// module id = 1224
// module chunks = 5